import { render, staticRenderFns } from "./Secretariat.vue?vue&type=template&id=7ff1e100&lang=pug&"
import script from "./Secretariat.vue?vue&type=script&lang=ts&"
export * from "./Secretariat.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports